module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbnMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzliOWI5Yjt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjMsOEg5QTgsOCwwLDAsMCw5LDI0SDIzQTgsOCwwLDAsMCwyMyw4Wk05LDIxQTUsNSwwLDAsMSw5LDExLDUsNSwwLDAsMSw5LDIxWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/off.svg
// module id = 4B4L
// module chunks = 1